module.exports = __webpack_public_path__ + "img/c1.4ba81134.png";